const datePicker = () => {
  const btn = document.getElementById('datePickerBtn');
  if (!btn) return;
  const trigger = $('#datePicker');
  trigger.datepicker({
    showOn: 'both',
  });
  btn.addEventListener('click', () => {
    $('.ui-datepicker-trigger').click();
  });
};
export default datePicker;



// WEBPACK FOOTER //
// ./src/js/module/datepicker.js